import { useAutoScroll } from '@/atoms'
import { LayoutComposer, ListFooter, NoEntries, NoResults } from '@/components/List'
import { StructuredVirtualList } from '@/components/StructuredVirtualList'
import { ComponentSize, FormColumn } from '@/components/layout'

import { Box } from '@mui/material'

import { Header } from './components/Header'
import { Item } from './components/Item'
import { useDataForList } from './hooks/useDataForList'
import { useListHandlers } from './hooks/useListHandlers'
import { useTexts } from './hooks/useTexts'

const getItemHeight = () => 79

interface Props {
  deviceEvents: Record<string, uui.domain.client.gps.wwgps.EventInfo>
}

export function EventsList(props: Props) {
  const { deviceEvents } = props
  const { handleOnSelect, handleOnSelectAll } = useListHandlers()
  const { structure, lastSelectedEvent, selection } = useDataForList()
  const texts = useTexts()

  useAutoScroll('eventInfos', lastSelectedEvent)

  const allSelected = selection.length >= structure.shownItems
  const multiSelect = selection.length > 1

  return (
    <FormColumn width={320} testid="form__column-primary">
      <Header />

      <Box width="100%" height="100%" flex="0 1 auto" position="relative">
        <LayoutComposer
          totalItems={structure.totalItems}
          shownItems={structure.shownItems}
          noResults={
            <NoResults title={texts.noResults.title} description={texts.noResults.description} />
          }
          noEntries={
            <NoEntries title={texts.noEntries.title} description={texts.noEntries.description} />
          }
          list={
            <ComponentSize
              render={size => {
                return (
                  <>
                    <StructuredVirtualList
                      itemsById={deviceEvents}
                      structure={structure}
                      listApiCategory="eventInfos"
                      getItemHeights={getItemHeight}
                      RenderItem={Item}
                      listHeight={size.height}
                      selectedItemIds={selection}
                      onSelect={handleOnSelect}
                      buffer={50}
                    />
                  </>
                )
              }}
            />
          }
        />
      </Box>

      {multiSelect && (
        <ListFooter
          label={texts.selectBtn(allSelected)}
          onToggleSelection={handleOnSelectAll}
          checked={allSelected}
        />
      )}
    </FormColumn>
  )
}
